import {
  Box, Button,
  CircularProgress,
  Grid,
  Input, InputLabel,
  Stack,
  styled,
  Tooltip, Typography
} from '@mui/material';
import { includes } from 'lodash';
import MicrosoftExcel from 'mdi-material-ui/MicrosoftExcel';
import { useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';
import Page from '../../components/Page';
import PageHeader from '../../components/page-header';
import BoxWrapper from '../../styles/BoxWrapper';
import TableLead from '../../views/lead/TableLead';
import MenuLead from '../../views/menu/MenuLead';

const LabelWrapper = styled(Box)(({ theme }) => ({
    marginLeft: '48px',
    background: '#90ff90',
    padding: '10px 16px',
    borderRadius: '8px',
    boxShadow: '0px 2px 4px -1px rgb(145 158 171 / 20%), 0px 4px 5px 0px rgb(145 158 171 / 14%), 0px 1px 10px 0px rgb(145 158 171 / 12%)',
    ":hover": { background: '#90ee90' }
}))

const LeadList = () => {
  const [reload, setReload] = useState(0);
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const inputFile = useRef(null);
  const [loading, setLoading] = useState(false)

  const sheetDownload = async () => {
      await apiService.get('/lead/excel', {
        responseType: 'blob',
        params: {
          ...filters,
          page,
          pageSize
        }
      }).then(response => {
        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = "리드(잠재고객).xlsx";
        document.body.appendChild(a);
        a.click();
      }).catch(error => {
        console.error(error);
      });
    }

  const sheetUpload = async (e) => {
    const [file] = Array.from(e.target.files);
    const ext = file.name.split('.').pop().toLowerCase();

    if (inputFile.current) {
        inputFile.current.value = "";
    }

    if (includes(['xls', 'xlsx'], ext)) {
        setLoading(true)

        const formData = new FormData()
        formData.append('file', file);

        await apiService.postFormData('/lead/upload', formData)
        .then(response => {
          const payload = response.data;
          toast.success('등록 되었습니다');

          setReload(reload + 1)                
        }).catch(error => {
          toast.error('등록에 실패했습니다. 다시 시도해주세요.');
          console.error(error);                 
        }).finally(() => {
          setLoading(false)
        });
    } else {
        toast.error('엑셀 xls, xlsx 파일 포맷만 가능합니다.')
    }
  }    

  return (
    <Page title="리드(잠재고객)">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                <Typography variant='h5' color='#666CFF'>
                  리드(잠재고객)
                </Typography>
            </Stack>
          }
          subtitle={
            <Typography variant='body2'>
              잠재고객 리스트를 보여줍니다.
            </Typography>
          }
        />
        <BoxWrapper>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <MenuLead setFilters={setFilters} setReload={setReload} />
          </Box>                  
        </BoxWrapper>
        <Stack direction="row" spacing={4} sx={{ mx: 6, py: 3 }}>
          <Tooltip title="모든 등록회원 정보 다운로드">
            <Button variant='contained' color="warning" startIcon={<MicrosoftExcel />} onClick={sheetDownload} >엑셀 다운로드</Button>
          </Tooltip>       
          <Tooltip title="모든 등록회원 정보 업로드">
            <LabelWrapper>
                <InputLabel htmlFor='excelFile' sx={{ fontSize: '14px', ":hover": {cursor: 'pointer'} }}>
                    {loading ? (
                    <CircularProgress
                        sx={{
                        color: 'common.white',
                        width: '20px !important',
                        height: '20px !important',
                        mr: theme => theme.spacing(2)
                        }}
                    />
                    ) : null}
                    엑셀 업로드
                </InputLabel>
                <form encType="multipart/form-data" >
                    <Input type="file" id="excelFile" style={{ display: 'none' }} onChange={sheetUpload} inputRef={inputFile} />
                </form>
            </LabelWrapper>
          </Tooltip>          
        </Stack>
        <Grid item xs={12}>
          <TableLead filters={filters} 
            submit={reload}
            page={page} 
            setPage={setPage} 
            pageSize={pageSize} 
            setPageSize={setPageSize}/>
        </Grid>
      </Grid>
    </Page>
  )
}

export default LeadList